export const defaultMaskReplacers: { [key: string]: RegExp } = {
  '#': /\d/,
  A: /[a-zA-Z]/i,
  N: /[a-zA-Z0-9]/i,
  X: /./
}
